var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "modal fade", attrs: { id: "imageadd", role: "dialog" } },
    [
      _c("div", { staticClass: "modal-dialog", class: _vm.size }, [
        _c("div", { staticClass: "modal-content" }, [
          _c("div", { staticClass: "modal-body" }, [
            _c("div", { staticClass: "flexbox" }, [
              _c(
                "div",
                { staticClass: "col-sm-12" },
                [
                  _c("image-input", {
                    attrs: {
                      uploadUrl: "Product/judge-image",
                      asin: this.asin,
                      shareLink: this.shareLink
                    },
                    on: {
                      close: function($event) {
                        _vm.$emit("close")
                      },
                      refresh: function($event) {
                        _vm.$emit("refresh")
                      }
                    }
                  })
                ],
                1
              )
            ])
          ])
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-487bf72a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-487bf72a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/productsNew/ProductNewImageAdd.vue
// module id = null
// module chunks = 